import { http } from '@/utils/http.js';
import { orgPath } from '@/utils/paths.js';

export const MembersApi = {
  index(query) {
    return http.get(`${orgPath()}/travelers`, { params: query }).then((response) => response.data);
  },

  store(data) {
    return http.post(`${orgPath()}/travelers`, data).then((response) => {
      // 200 response means the member trying to be created already exists
      // 201 response means we created this new member
      if (response.status === 200) {
        response.data.data.isExistingMember = true;
      }
      return response.data.data;
    });
  },

  show(id) {
    return http.get(`${orgPath()}/travelers/${id}`).then((response) => response.data.data);
  },

  update(id, data) {
    return http.patch(`${orgPath()}/travelers/${id}`, data).then((response) => {
      return response.data.data;
    });
  },

  destroy(id) {
    return http.delete(`${orgPath()}/travelers/${id}`).then((response) => response.data.data);
  },

  deactivate(id) {
    return http.post(`${orgPath()}/travelers/${id}/deactivate`).then((response) => response.data.data);
  },

  reactivate(id) {
    return http.post(`${orgPath()}/travelers/${id}/reactivate`).then((response) => response.data);
  },
};
